"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.SubFormContainer = function (props) {
    var children = props.children, onValidationChange = props.onValidationChange, subFormFormikProps = props.subFormFormikProps, valuesKey = props.valuesKey;
    var _a = react_1.default.useState(false), firstLoad = _a[0], setFirstLoad = _a[1];
    /**
     * Report back to consuming project if there has been a change in validation state.
     * if subFormikProps.errors object contains the valuesKey, that means the subform has errors.
     *
     * The subFormikProps are not fully initialised till the second render, so `firstLoad` boolean
     * is used (once) then switched to deal with that case.
     */
    react_1.default.useEffect(function () {
        var isValid = firstLoad && Object.prototype.hasOwnProperty.call(subFormFormikProps.errors, valuesKey);
        setFirstLoad(true);
        if (onValidationChange) {
            onValidationChange(isValid);
        }
        // Only interested in when the subFormFormikProps.errors dependency changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subFormFormikProps.errors]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
//# sourceMappingURL=SubFormContainer.js.map